import {Component, ElementRef, HostBinding, Input, OnInit} from '@angular/core';
import {LayoutService} from '../../services/layout.service';
import {ConfigService} from '../../config/config.service';
import {map, startWith, switchMap} from 'rxjs/operators';
import {NavigationService} from '../../services/navigation.service';
import {PopoverService} from '../../components/popover/popover.service';
import {MegaMenuComponent} from '../../components/mega-menu/mega-menu.component';
import {Observable, of} from 'rxjs';
import {TranslateService} from "@ngx-translate/core";
import {GetLanguage, HandleResponseError} from "../../../app/shared/functions/shared-functions";
import {secureStorage} from "../../../app/shared/functions/secure-storage";
import {environment} from "../../../environments/environment";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {CoreService} from "../../../app/services/core.service";
import {ToastrService} from "ngx-toastr";
@UntilDestroy()
@Component({
  selector: 'toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input() mobileQuery: boolean;
  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;

  languageList = [];
  features;
  navigationItems = this.navigationService.items;
  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(map(config => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(map(config => config.navbar.position === 'below-toolbar'));
  userVisible$: Observable<boolean> = this.configService.config$.pipe(map(config => config.toolbar.user.visible));

  megaMenuOpen$: Observable<boolean> = of(false);
  selectedLanguage;
  mainLogo = GetLanguage() === 'ar' ? environment.mainLogo_arabic : environment.mainLogo_english;

  language = GetLanguage();
  constructor(private layoutService: LayoutService,
              private configService: ConfigService,
              private navigationService: NavigationService,
              private translate: TranslateService,
              private coreService: CoreService,
              private toastr: ToastrService,
              private popoverService: PopoverService) {
  }

  ngOnInit() {
    this.languageList = [
      {code: 'en', label: 'English', flag: 'flag:united-states', prefix: 'EN'},
      {code: 'ar', label: 'Arabic', flag: 'flag:saudi-arabia', prefix: 'عربي'},
    ];
    this.selectedLanguage = this.languageList.find(x => x.code === GetLanguage()) || this.languageList[0];
    this.subscribeToQuickList();
  }

  subscribeToQuickList() {
    this.configService.quickList$.pipe(untilDestroyed(this)).subscribe(
      (res: any) => {
        this.features = res;
      }
    )
  }

  openQuickpanel(): void {
    // this.layoutService.openQuickpanel();
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement): void {
    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: MegaMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSearch(): void {
    this.layoutService.openSearch();
  }

  changeSiteLanguage(localeCode: string): void {
    const current = GetLanguage();
    this.selectedLanguage = this.languageList.find(x => x.code === localeCode);
    if (current !== localeCode) {
      secureStorage.setItem('lang', localeCode);
      window.location.reload();
    }
  }

  removeAll() {

  }

  removeQuickAccess(event, item) {
    // this.popoverRef.close();
    event.stopPropagation();
    this.coreService.deleteRequest(`admin/quick-list/${item?.id}`).pipe(untilDestroyed(this)).subscribe(
      res => {
        this.features = this.features.filter(x => x.id !== item.id);
        this.toastr.success(res?.message);
      }, error => {
        this.toastr.error(HandleResponseError(error));
      }, () => {
      }
    )
  }
}
